import { css } from '@headout/pixie/css';
import { strings } from 'const/strings';

const LoaderFallback = ({ isClosing }: { isClosing?: boolean }) => (
  <>
    <div
      className={css({
        display: 'flex',
        position: 'absolute',
        marginTop: '-9px',
        transform: isClosing ? 'scale(0)' : 'scale(1)',
        transition: 'transform 200ms cubic-bezier(.42, 0, .58, 1)',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '12px',
      })}
    >
      <div
        className={css({
          textStyle: 'Semantics/CTA/Regular',
          whiteSpace: 'nowrap',
          color: 'semantic.text.grey.2',
        })}
        style={{
          marginLeft: '3px',
        }}
      >
        {strings.POWERED_BY}
      </div>
      <div
        style={{
          position: 'absolute',
          left: '-5px',
          bottom: '-12.43px',
          width: '48px',
          height: '48px',
          background:
            'radial-gradient(56.44% 54.66% at 42.22% 51.16%, #FFF 0%, #FFF 44.26%, rgba(255, 255, 255, 0.80) 71.26%, rgba(255, 255, 255, 0.00) 87.92%)',
        }}
      />
      <div
        style={{
          position: 'absolute',
          bottom: '-12.43px',
          right: '-7.8px',
          width: '48px',
          height: '48px',
          background:
            'radial-gradient(56.44% 54.66% at 42.22% 51.16%, #FFF 0%, #FFF 44.26%, rgba(255, 255, 255, 0.80) 71.26%, rgba(255, 255, 255, 0.00) 87.92%)',
        }}
      />
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="171"
        height="25"
        viewBox="0 0 171 25"
        fill="none"
        className={css({ zIndex: 1 })}
      >
        <path
          d="M40.0369 9.14387C38.99 2.53142 30.4559 -0.480989 22.4825 0.782062C18.3489 1.43723 12.9218 4.19298 8.73754 7.25267C8.60246 7.06355 8.37957 6.8339 8.03172 6.69206C7.37655 6.42527 0.585119 5.94909 0.0751701 7.05341C-0.431401 8.15099 1.75361 12.4096 2.70259 13.4126C2.39864 14.0407 2.27031 14.6182 2.34799 15.1147C2.42904 15.6212 2.7296 16.1312 3.20578 16.6344C2.61478 17.8974 1.8583 22.5984 2.67895 23.4832C3.50635 24.3748 9.81823 21.825 10.3586 21.3691C10.6895 21.0888 10.828 20.7477 10.8854 20.5215C12.9455 21.1496 15.1946 21.646 17.4067 21.9466L19.1391 23.6554C19.7133 24.2228 20.4832 24.5538 21.2904 24.5673C22.1482 24.5842 23.3977 24.5403 24.9377 24.2971C26.6871 24.0202 28.2777 23.571 29.3246 23.2333C30.1216 22.9766 30.7835 22.416 31.1719 21.6731L32.0804 19.9203C37.0819 17.5969 40.7664 13.757 40.0369 9.14387ZM23.6679 3.55807C30.3344 2.50103 35.8324 4.96972 37.5783 7.99226C35.2008 7.20876 31.4826 6.31382 24.3129 7.44854C17.3695 8.54949 11.1286 10.7784 7.21783 12.5041C10.0816 9.58965 16.6705 4.66578 23.6679 3.55807ZM25.3531 19.0389C18.2138 20.1702 9.12591 17.4651 5.83658 15.6989C10.0479 16.0265 18.3995 16.2021 25.5186 15.0741C31.5569 14.1184 35.8729 12.3454 38.0343 10.8932C37.2035 14.2332 32.077 17.9751 25.3531 19.0389Z"
          fill="#8000FF"
        />
        <path
          d="M170.203 10.6252H165.622V18.2908C165.622 20.1357 165.654 20.2947 167.372 20.2947H170.203V23.8571H166.513C163.141 23.8571 161.551 22.7439 161.551 18.7043V10.6252H158.498V7.06272H161.551V2.48242H165.622V7.06272H170.203V10.6252Z"
          fill="#8000FF"
        />
        <path
          d="M146.764 24.1094C143.138 24.1094 140.721 21.7557 140.721 16.9845V7.06055H144.792V15.585C144.792 19.3701 145.778 20.4197 147.909 20.4197C150.263 20.4197 152.426 17.7797 152.426 13.8992V7.06055H156.497V23.855H152.426V22.8053C152.426 21.7875 152.649 21.1831 152.935 20.5152C153.062 20.2289 153.253 19.7836 152.839 19.6882C152.585 19.6246 152.49 19.8154 152.362 20.0699C151.535 21.7239 149.69 24.1094 146.764 24.1094Z"
          fill="#8000FF"
        />
        <path
          d="M130.067 6.80859C135.315 6.80859 138.464 10.6891 138.464 15.4603C138.464 20.2314 135.315 24.1119 130.067 24.1119C124.818 24.1119 121.669 20.2314 121.669 15.4603C121.669 10.6891 124.818 6.80859 130.067 6.80859ZM130.067 20.4223C132.834 20.4223 134.392 18.1957 134.392 15.4603C134.392 12.7248 132.834 10.4983 130.067 10.4983C127.299 10.4983 125.741 12.7248 125.741 15.4603C125.741 18.1957 127.299 20.4223 130.067 20.4223Z"
          fill="#8000FF"
        />
        <path
          d="M115.315 0.955078H119.387V23.8566H115.315V23.125C115.315 22.4888 115.474 21.9799 115.761 21.4074C115.92 21.0893 116.047 20.7712 115.697 20.644C115.411 20.5486 115.284 20.8667 115.22 20.9621C114.043 22.7115 112.453 24.111 109.908 24.111C105.55 24.111 102.592 20.2941 102.592 15.4594C102.592 10.6246 105.55 6.80768 109.908 6.80768C112.516 6.80768 114.297 8.07999 115.22 9.92483C115.284 10.0521 115.474 10.4656 115.792 10.3065C116.111 10.1475 115.92 9.76579 115.761 9.44771C115.474 8.87518 115.315 8.36626 115.315 7.6983V0.955078ZM110.862 20.4213C113.534 20.4213 115.315 18.1312 115.315 15.4594C115.315 12.7875 113.534 10.4974 110.862 10.4974C108 10.4974 106.664 12.7875 106.664 15.4594C106.664 18.1312 108 20.4213 110.862 20.4213Z"
          fill="#8000FF"
        />
        <path
          d="M84.2979 19.2454C84.2979 15.5239 87.0333 14.1562 90.4049 13.9653C93.3948 13.8063 96.0349 14.0925 96.0031 12.534C95.9713 11.3889 95.5259 10.1166 92.6315 10.1166C89.7688 10.1166 89.0372 11.2935 88.8145 12.6612H84.8068C85.3793 8.43078 89.0054 6.80859 92.7587 6.80859C96.6074 6.80859 100.074 8.0809 100.074 14.5697V23.8575H96.0031V22.6806C96.0031 21.9172 96.1939 21.3765 96.4802 20.8358C96.6074 20.5495 96.7346 20.2314 96.4484 20.1042C96.1303 19.9769 96.0031 20.295 95.9394 20.4541C94.9852 22.776 93.1404 24.1119 90.1505 24.1119C87.0015 24.1119 84.2979 22.0763 84.2979 19.2454ZM96.0031 15.2058C95.0488 16.2555 93.5221 16.4145 91.1047 16.669C89.3553 16.8598 88.3692 17.5278 88.3692 19.0227C88.3692 20.4223 89.7051 21.3129 91.5818 21.0584C93.7447 20.7721 95.9713 19.3726 96.0031 15.2058Z"
          fill="#8000FF"
        />
        <path
          d="M82.5492 15.2376C82.5492 15.6829 82.5174 16.001 82.4538 16.4781H70.2396C70.5259 19.0227 72.1799 20.5495 74.7245 20.5495C76.6648 20.5495 77.6508 19.4998 78.1279 18.0049H82.2629C81.5313 21.4719 79.1776 24.1119 74.6927 24.1119C69.2536 24.1119 66.2637 20.4541 66.2637 15.4603C66.2637 10.212 69.508 6.80859 74.6291 6.80859C78.5096 6.80859 82.5492 9.13055 82.5492 15.2376ZM70.3987 13.679H78.4778C78.3188 11.6434 77.1101 10.1166 74.7563 10.1166C71.989 10.1166 70.8122 11.6752 70.3987 13.679Z"
          fill="#8000FF"
        />
        <path
          d="M57.9783 6.80768C61.6043 6.80768 64.0217 9.16144 64.0217 13.9326V23.8566H59.9503V15.3321C59.9503 11.547 58.9643 10.4974 56.8332 10.4974C54.4794 10.4974 52.3165 13.1374 52.3165 17.0179V23.8566H48.2451V0.955078H52.3165V8.11179C52.3165 9.12963 52.1256 9.73398 51.8076 10.4019C51.6803 10.6882 51.4895 11.1335 51.903 11.2289C52.1575 11.2926 52.2529 11.1017 52.3801 10.8472C53.1435 9.16144 55.0519 6.80768 57.9783 6.80768Z"
          fill="#8000FF"
        />
      </svg>
    </div>
  </>
);
export default LoaderFallback;
